import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import { FiSearch } from "react-icons/fi";
import Swal from "sweetalert2";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const SubAdminNotificationSection = () => {
  const [getAllnotificationData, setGetAllnotificationData] = useState([]);
  const [updateId, setUpdateId] = useState("");
  const [notificationData, setNotificationData] = useState({
    NotificationTitle: "",
    NotificationDesc: "",
  });

  const [notificationUpdateData, setnotificationUpdateData] = useState({
    NotificationTitle: "",
    NotificationDesc: "",
  });

  const handleOnChange = (key, value) => {
    setNotificationData((notificationData) => ({
      ...notificationData,
      [key]: value,
    }));
  };

  const handleUpdateOnChange = (key, value) => {
    setnotificationUpdateData((notificationUpdateData) => ({
      ...notificationUpdateData,
      [key]: value,
    }));
  };

  const handleDelete = (id) => {
    Swal.fire({
      text: "Are you sure you won't be deleted?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        debugger;
        try {
          const setDeletenotificationData = await axios.delete(
            `api/admin/delete-notification/${id}`
          );
          if (setDeletenotificationData.data.isNotificationDeleted === true) {
            toast.success(setDeletenotificationData.data.msg);
            handleGetnotificationData();
          }
        } catch (error) {
          if (error.response.status === 400) {
            const message_400 = error?.response?.data?.message;
            toast.error(message_400);
          } else if (error.response.status === 401) {
            const message_401 = error?.response?.data?.message;
            toast.error(message_401);
          } else if (error.response.status === 404) {
            const message_404 = error?.response?.data?.message;
            console.log("message_404", message_404);
            toast.error(message_404);
          } else if (error.response.status === 500) {
            const message_500 = error?.response?.data?.message;
            toast.error(message_500);
          } else {
            toast.error("something went wrong");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("Cancelled");
      }
    });
  };
  const handleGetnotificationData = async () => {
    try {
      const getNotifiaction = await axios.get("api/admin/get-notification");
      console.log("getNotifiaction", getNotifiaction);
      if (getNotifiaction?.data?.isNotificationFound === true) {
        setGetAllnotificationData(getNotifiaction?.data?.data);
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };
  const handlePostnotificationData = async (e) => {
    e.preventDefault();
    try {
      const setNotificationData = await axios.post(
        "api/admin/add-notification",
        notificationData
      );
      if (setNotificationData?.data?.isNotificationCreated === true) {
        toast.success(setNotificationData?.data?.msg);
        window.location.reload();
        handleGetnotificationData();
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };

  const handleUpdatenotificationData = async (e) => {
    e.preventDefault();
    try {
      const setUpdatenotificationData = await axios.put(
        `api/admin/update-notification/${updateId}`,
        notificationUpdateData
      );
      if (setUpdatenotificationData.data.isNotificationUpdated === true) {
        toast.success(setUpdatenotificationData.data.msg);
        handleGetnotificationData();
        window.location.reload();
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };
  console.log("updateId", updateId);
  useEffect(() => {
    handleGetnotificationData();
  }, []);
  return (
    <Layout>
      <form className="d-flex mb-3 my-3">
        <div className="row w-100 justify-content-between g-3">
          <div className="col-lg-5 col-md-6 col-sm-12">
            <div className="input-group ">
              <input
                type="text"
                className="form-control"
                placeholder="Search Address"
                aria-label="Search"
                aria-describedby="button-addon2"
              />
              <button
                className="button-styles"
                type="button"
                id="button-addon2"
              >
                <FiSearch />
              </button>
            </div>
          </div>
        </div>
      </form>
      <button
        type="button"
        className="button-styles my-3"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        data-bs-whatever="@mdo"
      >
        <i class="fa-solid fa-plus mx-2"></i>
        Add Notification
      </button>
      <div className="table-responsive">
        <div>
          <div className="table-responsive table-box">
            <table className="table table-bordered">
              <thead>
                <tr className="table-head">
                  <th>Notification Id</th>
                  <th>Notification Title</th>
                  <th>Notification Description</th>
                  <th>CreatedAt</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {getAllnotificationData.map((nft, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{nft.NotificationTitle}</td>
                    <td>{nft.NotificationDesc}</td>
                    <td>{nft.createdAt}</td>
                    <td>
                      <button
                        className="button-styles"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#editcourse"
                        onClick={() => (
                          setnotificationUpdateData({
                            NotificationTitle: "",
                            NotificationDesc: "",
                          }),
                          setUpdateId(nft._id)
                        )}
                      >
                        <i class="fa-solid fa-pen-to-square mx-2"></i>
                        Edit
                      </button>
                    </td>
                    <td>
                      <button
                        className="button-styles"
                        type="button"
                        onClick={() => handleDelete(nft._id)}
                      >
                        <i class="fa-solid fa-trash mx-2"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/*Add modal form */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Notification
              </h5>
              <button
                type="button"
                className="btn-close cus-btn-close "
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => handlePostnotificationData(e)}>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Notification Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={notificationData.NotificationTitle}
                    onChange={(e) =>
                      handleOnChange("NotificationTitle", e.target.value)
                    }
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Notification Description
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={notificationData.NotificationDesc}
                    onChange={(e) =>
                      handleOnChange("NotificationDesc", e.target.value)
                    }
                  />
                </div>

                <button className="button-styles" type="submit">
                  <i class="fa-solid fa-thumbs-up mx-2"></i>Save
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/*Edit  modal form */}
      <div
        className="modal fade"
        id="editcourse"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Notification
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => handleUpdatenotificationData(e)}>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Notification Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={notificationUpdateData.NotificationTitle}
                    onChange={(e) =>
                      handleUpdateOnChange("NotificationTitle", e.target.value)
                    }
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Notification Description
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={notificationUpdateData.NotificationDesc}
                    onChange={(e) =>
                      handleUpdateOnChange("NotificationDesc", e.target.value)
                    }
                  />
                </div>

                <button className="button-styles" type="submit">
                  <i class="fa-solid fa-thumbs-up mx-2"></i>Update
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" />
    </Layout>
  );
};
export default SubAdminNotificationSection;
